import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import {
  IGetSefHealthStatusResponse,
  ResultOfArhivskaExistsResponse,
  SefClient,
} from '@kodit/core/data-api';
import { SEF_HEALTH_CHECK_IN_SECONDS } from '@kodit/core/shared';

const colors = [
  '#1abc9c',
  '#2ecc71',
  '#3498db',
  '#9b59b6',
  '#34495e',
  '#16a085',
  '#27ae60',
  '#2980b9',
  '#8e44ad',
  '#2c3e50',
  '#f1c40f',
  '#e67e22',
  '#e74c3c',
  '#95a5a6',
  '#f39c12',
  '#d35400',
  '#c0392b',
  '#bdc3c7',
  '#7f8c8d',
  '#5DDEA3',
  '#FF5959',
];
@Injectable({
  providedIn: 'root',
})
export class SefService {

  private intervalId: number | null = null;

  isSefActive$ = new BehaviorSubject<IGetSefHealthStatusResponse>({
    isActive: null,
    background: null,
  });

  hasSefKey$ = new BehaviorSubject<boolean>(false);

  constructor(
    private _sefClient: SefClient,
  ){}

  get getIsSefActive(): Observable<IGetSefHealthStatusResponse> {
    //return this.isSefActive$.asObservable();
    return of({ isActive: true });
  }

  set setIsSefActive(isActive: IGetSefHealthStatusResponse) {
    this.isSefActive$.next(isActive);
  }

  get getHasSefKey() {
    return this.hasSefKey$.asObservable();
  }

  set setHasSefKey(sef: boolean) {
      this.hasSefKey$.next(sef);
  }

  // shouldDisplayApiKeyDialog$ = new BehaviorSubject<boolean>(null);

  // get getShouldDisplayApiKeyDialog() {
  //   return this.shouldDisplayApiKeyDialog$.asObservable();
  // }

  // set setShouldDisplayApiKeyDialog(show: boolean) {
  //   this.shouldDisplayApiKeyDialog$.next(show);
  // }



  // public startSefHealthCheck() {
  //   this.performSefHealthCheck();
  //   this.intervalId = window.setInterval(() => {
  //     this.performSefHealthCheck();
  //   }, SEF_HEALTH_CHECK_IN_SECONDS*1000);
  // }
  //
  // public stopSefHealthCheck() {
  //   if (this.intervalId) {
  //     window.clearInterval(this.intervalId);
  //     this.intervalId = null;
  //   }
  // }

  // private performSefHealthCheck() {
  //   this._sefClient.getSefHealhStatus().subscribe({
  //     next: (response) => {
  //       if (response.succeeded) {
  //         const sefStatus: IGetSefHealthStatusResponse = {
  //           isActive: response.data.isActive,
  //           background: colors[colors.length-1],
  //         };
  //         this.setIsSefActive = sefStatus;
  //       } else {
  //         console.error('SEF health status check failed:', response);
  //       }
  //     },
  //     error: (error) => {
  //       console.error('Error fetching SEF health status sa fronta:', error);
  //     },
  //   });
  // }
}
